export const getAssetSrc = (assetPath: string) =>
  process.env['NEXT_PUBLIC_VERCEL_URL'] ? `https://${process.env['NEXT_PUBLIC_VERCEL_URL']}${assetPath}` : assetPath;
